import { useState, useEffect } from 'react';
const blankImg = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export function convertImageToBase64(imgUrl, callback) {
  	const image = new Image();
  	image.crossOrigin='anonymous';
  	image.onload = () => {
  		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		canvas.height = image.naturalHeight;
		canvas.width = image.naturalWidth;
		ctx.drawImage(image, 0, 0);
		const dataUrl = canvas.toDataURL();
		callback && callback(dataUrl);
  	}
	image.onerror = () => {
		callback(blankImg); // base64 of blank image
	}
  	image.src = imgUrl;
}

window.convertImageToBase64 = convertImageToBase64;

export function useGetBase64Img(imageUrl, shouldExecute){
	const [base64Image, setBase64Image] = useState(null);
	
	useEffect(() => {
		if(shouldExecute && !base64Image){
			try{
				const type = imageUrl.substring(imageUrl.lastIndexOf(".") + 1);
				if(type === 'svg'){
					setBase64Image(imageUrl);
				}
				else {
					convertImageToBase64(imageUrl, (imageEncoded) => {
						setBase64Image(imageEncoded);
					});					
				}

			}
			catch(e){
				setBase64Image(blankImg);
			}

		}
	});
	
	return [base64Image];

}